<template>
  <div class="customer-manage conmon-top special-customer aud-content">
    <el-container>
      <div style="padding: 0;width: 100%;" class="table-first-style">
        <div class="base-input ovf-hd" style="margin-bottom: 10px;">
          <el-row class="search-title">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold;">
              </i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right customer-search-record">
              <span style="margin-left: 20px">筛选记录：</span>
              <el-select id="infoId" v-model="searchValue" placeholder="筛选记录"
                style="width: 190px!important;margin: 0 10px;" filterable @change="searchOptionsChange"
                         @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                <el-option v-for="item in searchOptions" :key="item.id" :label="item.name" :value="item.id" >
                </el-option>
              </el-select>
              <span class="fold-button aud-show-btn" @click="changeSearchType">{{ showText }}</span>
              <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="changeSearchType" style="margin-right: 32px"></i>
              <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="changeSearchType" style="margin-right: 32px"></i>
            </el-col>
          </el-row>
          <!--高级查询-->
          <el-row class="search-content" style="min-height: 210px!important;height: auto;" v-show="hide">
           <div style="display: flex;justify-content: space-between;align-items: center;padding: 10px 0">
             <div>
               <span style="margin-left: 20px;">查询条件:</span>
             </div>
            <div class="hei-ser" style="margin-top: 0px;">
              <el-button type="primary" class="add-btn btn-right" @click="reset">重置</el-button>
              <el-button v-if="butsObj.set_tag" type="primary" class="add-btn btn-right" style="margin-right: 16px;" @click="setTagsAction">
                设置标签</el-button>
              <el-button v-if="butsObj.save_screen" type="primary" class="add-btn" @click="saveSearchItem" style="margin-right:16px">保存筛选
              </el-button>
              <!--<el-button type="primary" class="add-btn" @click="addQuery" style="margin-right:16px">保存为动态群组</el-button>-->
              <el-button type="primary" class="add-btn" @click="startSearchQuery" style="margin-right:16px">开始查询
              </el-button>
            </div>
           </div>
            <higher-search-audiences :modelId="$route.params.id"
              class="common-search-formtype customer-manage-higher-search group-item-style high-search-cascader aud-manage"
              :forSonTerms="forSonTerms" :isAnalyse="isAnalyse" :allRelationship="allRelationship" @change="getAllTerms"
              style="margin-top: 10px"></higher-search-audiences>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0;">
          <el-col :span="6" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>{{ useName }}列表</span>
          </el-col>
          <el-col :span="18" class="text-align-right">

            <el-popover class="aud-pop-con" placement="bottom-end" width="580" v-model="visible2">
              <div style="margin-top: 10px;max-height: 290px;" :class="rowData.length >= 25 ? 'scroll-pop' : ''">
                <div style="text-align: right;margin-right: 10px;margin-top: -5px;">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllAttr" @change="handleCheckAllChange">
                    全选
                  </el-checkbox>
                </div>
                <el-checkbox-group class="aud-popover" @change="handleCheckedAttrChange" v-model="checkedRowData"
                  :min="1" :max="100000">
                  <draggable class="list-group" :list="rowData" @change="log">
                    <span class="aud-pop-span" v-for="(item, index) in rowData" :key="index">
                      <img class="pop-img" src="/static/img/line.png" />
                      <el-checkbox :label="item.identity">
                        {{ item.name }}
                      </el-checkbox>
                    </span>
                  </draggable>
                </el-checkbox-group>
              </div>
              <div class="aud-pop-btn-content">
                <el-button class="btn-cancel" size="mini" @click="visible2 = false">取 消</el-button>
                <el-button class="btn-confirm" type="primary" size="mini" @click="setRowList">确定</el-button>
              </div>

              <el-button v-show="butsObj.set_column" class="add-btn btn-right" type="primary" slot="reference">
                设置列
              </el-button>
            </el-popover>
            <el-button type="primary" v-if="butsObj.export" class="add-btn list-btn-margin" @click="downloadCustomer">导出</el-button>
            <el-button type="primary" v-if="butsObj.add" class="add-btn list-btn-margin" @click="openDialog">新建</el-button>
            <span class="title-tips el-icon-question" @mouseenter="showTipsenter()" @mouseleave="showTipsleave()"
              v-if="cloudShopMid != 0&& paramsId == cloudShopMid"></span>
            <div class="title-attribute" id="tipsConent">
              <p>
                1.进货数量，进货次数，进货金额，扫码商品数，扫码人数，扫码率，动销率，活跃度统计的是近一年的数据
              </p>
              <p>
                2.动销率：销售商品数量/进货商品数量，每箱中单个产品被扫码后，一个月后视为该箱商品被整体动销
              </p>
            </div>
          </el-col>
        </el-row>
        <!-- 表格 -->
        <el-table @sort-change="sortChange" class="audiences-table-content" v-loading="loadList" :data="tableData"
          border>
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="openDialog">新建</span></div>
          </template>
          <el-table-column :sortable="data.isSort" min-width="160" :label="data.label" v-for="data in headerList"
            :key="data.identity" :prop="data.identity">
            <template slot-scope="scope">
              <img v-if="data.identity == 'avatar'"
                style="width: 32px; height: 32px; display: block; border-radius: 50%; text-align: left; float: left; margin-right: 10px;"
                :src="scope.row[data.identity] | showImgUrl" />
              <div v-else :class="isSafari ? 'aud-show-divs' : 'aud-show-div'">
                <span :title="scope.row[data.identity]">{{ scope.row[data.identity].replace(/ /, '&nbsp;') }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="aud-operatopn-div" fixed="right" align="center" label="操作"  width="140">
            <template slot-scope="scope" v-if="scope.row.id !== ''">
              <div class="op-link">
                <span class="op-link" v-if="butsObj.details" @click="toAudDetail(scope.row)" size="small">查看</span>
              </div>
              <div class="op-link">
                <span class="op-link deleteColor" v-if="butsObj.del" @click="deleteItem(scope.row)" size="small">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-container>

    <div class="table-foot" style="text-align: right">
      <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-size="limit" :current-page="page"
        layout="total, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>

    <!--添加弹窗-->
    <el-dialog class="cellDialog aud-add-dia" :title="'新建' + useName" :visible.sync="adddialog" width="590px">
      <span style="font-size: 16px;" v-if="attributeList.length === 0">
        <i class="el-icon-error" style="color: #f36d6f;"></i>
        没有必填属性！请前往受众类型配置属性。
      </span>
      <el-form v-if="attributeList.length > 0" ref="customer" :rules="rules" :model="customer"
        style="height: 400px;overflow: auto;">
        <el-form-item :prop="attr.identity" :label="attr.name + ':'" :label-width="addLabelWidth" :key="'attr' + index"
          v-for="(attr, index) in attributeList">
          <diy-audiences-attribute :key="index" :type="attr.type" :attr="attr" v-model="customer[attr.identity]"
            :option='attr.option'>
          </diy-audiences-attribute>
        </el-form-item>
      </el-form>
      <div v-if="attributeList.length > 0" slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="cancelAdd" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" :disabled="isDisabled" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <!--保存为动态群组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="保存为动态群组" :visible.sync="addGroup" width="520px">
      <el-form ref="addGroupForm" :model="addGroupForm" :rules="addGroupFormRules">
        <el-form-item label="群组名字:" prop="name" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="addGroupForm.name" auto-complete="off" placeholder="输入群组名字">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="addGroup = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" :disabled="isDisabledQuery" type="primary" @click="confirmAddGroup">确 定
        </el-button>
      </div>
    </el-dialog>
    <!--保存筛选条件弹窗-->
    <el-dialog class="cellDialog base-dialog" title="保存为筛选条件" :visible.sync="saveSearch" width="520px">
      <el-form ref="saveSearchForm" :model="saveSearchForm" :rules="saveSearchFormRules">
        <el-form-item label="条件名字:" prop="name" :label-width="addLabelWidth" ref="againValue">
          <el-input class="stockInput" type="text" v-model="saveSearchForm.name" auto-complete="off"
            placeholder="输入筛选条件名字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="saveSearch = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" :disabled="isDisabledSearch" type="primary" @click="confirmSaveSearch">确 定
        </el-button>
      </div>
    </el-dialog>
    <!--点击导出按钮弹窗-->
    <el-dialog class="cellDialog base-dialog special-select-dialog" title="受众导出" :visible.sync="exportDialog"
      width="590px">
      <!-- <div class="export-number">
        当前导出人数: {{ exportNumber }}
      </div> -->
      <el-form ref="exportForm" :model="exportForm">
        <el-form-item label="当前导出人数:" :label-width="addLabelWidth" class="special-select-form-item">
          <p style="margin: 0;text-align: left;">{{ exportNumber }}</p>
        </el-form-item>
        <el-form-item label="选择属性:" :label-width="addLabelWidth" class="special-select-form-item">
          <el-select @change="chooseAttrSelect" v-model="exportForm.chooseIdentities" multiple placeholder="请选择">
            <el-option v-for="item in identities" :key="item.identity" :label="item.name" :value="item.identity">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="isAllIdentity" label="全部属性:" :label-width="addLabelWidth">
          <el-checkbox v-model="checked" @change="chooseAll">全选</el-checkbox>
        </el-form-item>
        <el-form-item class="isAllIdentity" label="受众身份:" :label-width="addLabelWidth">
          <el-checkbox v-model="exportChecked">导出</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="exportDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" :disabled="isDisabledExport" type="primary" @click="startDownload">确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 设置标签 -->
    <el-dialog class="cellDialog base-dialog" title="设置标签" :visible.sync="setTagDialog" width="520px">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: -20px; margin-bottom: 10px;">
        <el-tab-pane label="添加标签" name="ADD">
          <tags-table v-model="tagsArray" :modelId="modelId">
          </tags-table>
        </el-tab-pane>
        <el-tab-pane label="移除标签" name="DELETE">
          <delete-tags-table v-model="tagsArray" :modelId="modelId">
          </delete-tags-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="setTagDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" :disabled="isDisabledQuery" type="primary" @click="confirmTagsAction">确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSourceData, getCustomerStage, getGroupList, getBigWheelList, getWechatPublicListForNode, getQrCodeList, WePagesList, getMessageListForNode, addGroup, getAudiencesListHigher } from '@/api/customer.js'
import { getCustomerSources, getAudGroupGroupList, getAudGroupList, getCusStageList, getAudListShowSix, setAudRowList, deleteAudience, getMyAboutModelList, getCusTypes, getCusAttrList, getCusAddAttrList, addAudiences, getAudiencesList, getCusSearchList, addAudSearchCondition, getAudExportList, batchAddOrRemoveTags } from '@/api/set.js'
import DiyAudiencesAttribute from '@/components/common/diy-audiences-attribute'
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import HigherSearchAudiences from './../common/higher-search-audiences.vue'
import tagsTable from './../common/tags-table.vue'
import deleteTagsTable from './../common/delete-tags-table.vue'
import { mapMutations, mapGetters } from 'vuex'
import {  NO_EXPORT, EXPORT, initForSonTerms, resetForSonTerms, elseForSonTermsList, queryObj, vmAllTermsObj, vmForSonTermsList, aduRelateOpsOne, aduRelateOpsFive,
  aduRelateOpsEight, aduRelateOpsSeven, aduRelateOpsSix, termsObj
} from './constant.js'
import { butonsList, getMenId } from '@/api/analyse.js'
import { higherAduRelateOpsOne, higherAduRelateOpsFive, higherAduRelateOpsSix, selDicAddList,
  higherAduRelateOpsSeven, multipleModelList, higherAduRelateOpsEight, datePickerArr

} from '../common/constant'
import { judgeIsEmpty } from '../../api/publicMethods'
import draggable from 'vuedraggable'
export default {
  name: 'customerManage',
  data () {
    const checkName = (rule, value, callback) => {
      if (value.length ===0) {
        callback(new Error('群组名字不能为空'))
      }
      callback()
    }
    return {
      inputFlagOne: null,
      isAnalyse: false,
      exportChecked: false,
      isHight: false,
      modelId: '',
      tagsArray: [],
      activeName: 'ADD',
      setTagDialog: false,
      isSafari: false,
      showText: '收起查询',
      source: [],
      stages: [],
      headerList: [],
      rowList: [],
      checkedRowData: [],
      rowData: [],
      visible2: false,
      titleData: [],
      audiencesData: [],
      regionData: regionDataPlus,
      selectedOptions: [],
      // 属性列表
      attributeList: [],
      // 客户属性
      customer: {},
      useName: '',
      modelData: [],
      saveSearchFormRules: {
        name: [
          { required: true, validator: checkName, trigger: 'blur' }
        ]
      },
      addGroupFormRules: {
        name: [
          { required: true,validator: checkName, trigger: 'blur' }
        ]
      },
      loadList: true,
      checked: false,
      isDisabledExport: false,
      exportDialog: false,
      exportForm: {
        chooseIdentities: []
      },
      identities: [],
      exportNumber: '',
      searchOptions: [],
      searchValue: '',
      tableData: [],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      addGroup: false,
      saveSearch: false,
      addForm: {
        name: '',
        phone: '',
        sex: 1,
        mobile_verified: 0,
        email: '',
        email_verified: 0
      },
      addGroupForm: {
        name: ''
      },
      saveSearchForm: {
        name: ''
      },
      addLabelWidth: '95px',
      dialogType: 0,
      editId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      searchTmp: {
        keywords: ''
      },
      allRelationship: 'and',
      search: {
        keywords: ''
      },
      isDisabled: false,
      isDisabledQuery: false,
      isDisabledSearch: false,
      allTerms: {},
      searchTerms: {},
      lastId: 0,
      searchType: 0,
      allRelationshipSearch: '',
      forSonTerms: initForSonTerms(),
      result: [],
      len: 0,
      changeSearchValue: '',
      isShowSearchRes: false,
      is_searched: false,
      // 设置列全选或者取消
      checkedAttr: [],
      checkAllAttr: '',
      isIndeterminate: true,
      cloudShopMid: Lockr.get('cloudShopMid'),
      paramsId: '',
      isSearch:false,
      butsObj: { // button按钮列表
        save_screen: false,
        set_tag: false,
        add: false,
        export: false,
        set_column: false,
        details: false,
        del: false
      }
    }
  },
  components: {
    'higher-search-audiences': HigherSearchAudiences,
    'diy-audiences-attribute': DiyAudiencesAttribute,
    'tags-table': tagsTable,
    'delete-tags-table': deleteTagsTable
  },
  computed: {
    ...mapGetters([
      'getQuery'
    ]),
    rules () {
      let rule = {}
      for (let item of this.attributeList) {
        if (item.type === 'input' || item.type === 'number') {
          rule[item.identity] = [
            { required: true, message: '请输入' + item.name, trigger: 'blur' }
          ]
        }
        if (item.type === 'multipleSelect' || item.type === 'model') {
          rule[item.identity] = [
            { required: true, message: '请输入' + item.name, trigger: 'change', type: 'array' }
          ]
        }
        if (item.type === 'select' || item.type === 'datePicker' || item.type === 'dateTimePicker' || item.type === 'addressPicker') {
          rule[item.identity] = [
            { required: true, message: '请输入' + item.name, trigger: 'change' }
          ]
        }
      }
      return rule
    }
  },
  methods: {
    ...mapMutations([
      'setQuery'
    ]),
    focusWayOne () {
      if (this.inputFlagOne) {
        this.$refs['selectOne'].blur()
      }
    },
    visibleChangeOne (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showTipsenter () {
      document.getElementById('tipsConent').style.display = 'block'
    },
    showTipsleave () {
      document.getElementById('tipsConent').style.display = 'none'
    },
    confirmTagsAction () {
      if (this.tagsArray.length === 0) {
        _g.toastMsg('error', '请选择标签')
        return
      }
      if (this.isDisabledQuery === true) {
        return
      }
      this.isDisabledQuery = true
      let modelId = this.$route.params.id
      let termsSend = JSON.parse(JSON.stringify(this.searchTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          one.startValue = one.startValue + ''
          one.endValue = one.endValue + ''
        }
      }
      let params = {
        modelId,
        search: termsSend,
        action: this.activeName,
        tagNameList: this.tagsArray
      }
      batchAddOrRemoveTags(params).then(res => {
        setTimeout(() => {
          this.isDisabledQuery = false
        }, 1500)
        if (res.data.code === '200') {
          _g.toastMsg('success', res.data.message)
          this.setTagDialog = false
          this.tagsArray = []
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    handleClick () {
      this.tagsArray = []
    },
    setTagsAction () {
      if (this.isHight === false) {
        _g.toastMsg('error', '请先进行查询')
        return
      }
      this.modelId = this.$route.params.id
      this.setTagDialog = true
    },
    aaa (val) {
      this.checkedRowData = val
    },
    // 设置列拖拽排序
    log (evt) {
      window.console.log(evt)
      let arr = []
    },
    // 排序
    sortChange (val) {
      if (val.order === 'ascending') {
        this.getAsc(val.prop)
      }
      if (val.order === 'descending') {
        this.getDesc(val.prop)
      }
      if (val.order === null) {
        for (let one of this.rowList) {
          one.sortRole = ''
        }
        this.load()
      }
    },
    // 请求初始来源
    loadSource () {
      getCustomerSources(1, 0, '').then((res) => {
        if (res.data.code == 200) {
          for (let one of res.data.result.list) {
            this.source[one.id] = one.name
          }
        }
      })
    },
    // 请求受众等级
    loadStage (modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      getCusStageList(modelId).then((res) => {
        if (res.data.code == 200) {
          res.data.result.unshift({
            id: 0,
            name: '未知'
          })
          for (let one of res.data.result) {
            this.stages[one.id] = one.name
          }
        }
      })
    },
    // 跳转受众详情
    toAudDetail (item) {
      let modelId = this.$route.params.id
      let temp = ''
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          for (let item of res.data.result) {
            if (modelId == item.id) {
              temp = item.template
            }
          }
          if (temp === 'B端模板') {
            router.push({ path: '/home/model-business', query: { id: item.id, modelId: modelId, useName: this.useName } })
          } else {
            router.push({ path: '/home/model-consumer', query: { id: item.id, modelId: modelId, useName: this.useName } })
          }
        }
      })
    },
    // 添加新建的受众
    submitForm () {
      this.$refs.customer.validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          return false
        }
      })
    },
    handleCheckAllChange (val) {
      this.checkedRowData = val ? this.checkedAttr : []
      this.isIndeterminate = false
    },
    handleCheckedAttrChange (value) {
      this.checkedRowData = value
      let checkedCount = value.length
      this.checkAllAttr = checkedCount === this.checkedAttr.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedAttr.length
    },
    // 设置列
    setRowList () {
      if (this.checkedRowData.length === 0) {
        _g.toastMsg('error', '请选择列')
        return
      }
      let modelId = this.$route.params.id
      this.rowList = []
      let rowDatas = JSON.parse(JSON.stringify(this.rowData))
      for (let i in rowDatas) {
        for (let one of this.checkedRowData) {
          if (one === rowDatas[i].identity) {
            rowDatas[i].isChecked = 1
            rowDatas[i].sort = i
            break
          } else {
            rowDatas[i].isChecked = 0
          }
        }
      }
      setAudRowList(modelId, JSON.stringify(rowDatas)).then((res) => {
        if (res.data.code == 200) {
          _g.toastMsg('success', '设置列成功')
          this.loadList = true
          this.loadSix()
          this.visible2 = false
        } else {
          _g.toastMsg('error', res.data.message)
          this.loadSix()
          this.visible2 = false
        }
      })
    },
    // 升序
    getAsc (identity) {
      for (let one of this.rowList) {
        one.sortRole = ''
        if (one.identity === identity) {
          one.sortRole = 'asc'
        }
      }
      this.load()
    },
    // 降序
    getDesc (identity) {
      for (let one of this.rowList) {
        one.sortRole = ''
        if (one.identity === identity) {
          one.sortRole = 'desc'
        }
      }
      this.load()
    },
    // 导出属性选择select
    chooseAttrSelect (val) {
      if (val.length < this.identities.length) {
        this.checked = false
      } else if (val.length === this.identities.length) {
        this.checked = true
      }
    },
    // 选择全部导出属性
    chooseAll (val) {
      if (val === true) {
        this.exportForm.chooseIdentities = []
        for (let item of this.identities) {
          this.exportForm.chooseIdentities.push(item.identity)
        }
      }
      if (val === false) {
        this.exportForm.chooseIdentities = []
      }
    },
    // 获取列表名字
    getAudiencesName (modelId, to) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.modelData = res.data.result
          let id = this.$route.params.id
          for (let item of this.modelData) {
            if (item.id == id) {
              this.useName = item.name
              let arr = to.meta.routeArr
              arr[0].name = item.name + ''
              arr[1].name = item.name + '管理'
              this.$store.state.breadcrumb = to.meta.routeArr
            }
          }
        }
      })
    },
    searchLoad () {
      this.page = 1
      this.search = JSON.parse(JSON.stringify(this.searchTmp))
      this.lastId = 0
      this.load()
    },
    // 筛选条件select查询
    searchOptionsChange (value) {
      this.loadList = true
      for (let i in this.searchOptions) {
        if (value === this.searchOptions[i].id) {
          this.searchTerms = JSON.parse(this.searchOptions[i].query)
          for(let s in this.searchTerms.termsGroup) {
            for (let s1 in this.searchTerms.termsGroup[s].terms){
              if(this.searchTerms.termsGroup[s].terms[s1].relationOptions === null) {
                // console.log(this.getRelationsOptionWay(this.searchTerms.termsGroup[s].terms[s1]), '78888=======')
                if(this.searchTerms.termsGroup[s].terms[s1].attr==='attr') {
                  this.searchTerms.termsGroup[s].terms[s1].relationOptions  = this.getRelationsOptionWay(this.searchTerms.termsGroup[s].terms[s1])
                } else {
                  this.searchTerms.termsGroup[s].terms[s1].relationOptions  = []
                }
              }
            }
          }
          // console.log(this.searchTerms, '筛选记录数据')
          this.forSonTerms = JSON.stringify(this.searchTerms)
          this.allRelationship = this.searchTerms.allRelationship
        }
      }
      if(value === '') {
        this.isSearch = false
      } else {
        this.isSearch = true
      }
      this.searchQuery()
    },
    // 根据类型判断相对关系
    getRelationsOptionWay (item) {
      /* -------------自定义属性的相对关系------------ */
      let relationOptions = []
      // 文本
      if (item.selectedOptions[1].split('@')[1] === 'input') {
        relationOptions = higherAduRelateOpsOne()
      }

      // 地址 单个选择列表
      if (selDicAddList.includes(item.selectedOptions[1].split('@')[1])) {
        relationOptions = higherAduRelateOpsFive()
      }
      // 时间
      if (datePickerArr.includes(item.selectedOptions[1].split('@')[1])) {
        relationOptions = higherAduRelateOpsEight()
      }

      // 多个选择列表  ||  关联模型
      if (multipleModelList.includes(item.selectedOptions[1].split('@')[1])) {
        relationOptions = higherAduRelateOpsSeven()
      }
      // 数值
      if (item.selectedOptions[1].split('@')[1] === 'number') {
        // higherAduRelateOpsSix : 等于 不等于 大于 小于 区间
        relationOptions = higherAduRelateOpsSix()
      }
      return relationOptions
    },
    getQueryconditionAction (modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      // 获取筛选记录列表
      getCusSearchList(modelId).then((res) => {
        if (res.data.code == 200) {
          let qur = queryObj
          res.data.result.unshift({
            id: '',
            name: '全部',
            query: JSON.stringify(qur)
          })
          this.searchOptions = res.data.result
          // console.log( this.searchOptions, ' this.searchOptions')
        }
      })
    },
    // 获取客户属性
    getCustomerAttributes () {
      let modelId = this.$route.params.id
      getCusAttrList(modelId).then((res) => {
        if (res.data.code == 200) {
          this.identities = res.data.result
        }
      })
    },
    // 导出弹窗打开
    downloadCustomer () {
      if (this.totalCount > 1000000) {
        _g.toastMsg('error', '最多导出100万条数据，请重新选择')
        return
      } else {
        this.exportDialog = true
        this.exportNumber = this.totalCount
        this.exportForm.chooseIdentities = []
        this.checked = false
      }
    },
    // 开始下载
    startDownload () {
      if (this.exportNumber > 1000000) {
        _g.toastMsg('error', '最多导出100万条数据，请重新选择')
        return
      }
      if (this.exportForm.chooseIdentities.length === 0 && this.checked === false) {
        _g.toastMsg('error', '请选择要导出的客户属性')
        return
      }
      if (this.exportNumber === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let search = {}
      // 开始传导出的查询参数
      for (let item of this.searchTerms.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          one.attr = one.selectedOptions[0]
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          // one.optionOther = null
          // one.qrcodeOptions = null
          // one.templateOption = null
        }
      }
      search = this.searchTerms
      let modelId = this.$route.params.id
      // 是否全选
      let rowLists = []
      // 属性集合
      for (let one of this.exportForm.chooseIdentities) {
        for (let item of this.identities) {
          if (one === item.identity) {
            rowLists.push({
              identity: one,
              type: item.type,
              sortRole: ''
            })
          }
        }
      }
      // 发送下载参数
      const isImportIdentitys = this.exportChecked ? EXPORT : NO_EXPORT
      getAudExportList(search, modelId, rowLists, isImportIdentitys).then(response => {
        _g.toastMsg('href', '')
        this.exportDialog = false
      }).catch((error) => {
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 改变查询类型
    changeSearchType () {
      this.hide = !this.hide
      if (this.hide) {
        this.showText = '收起查询'
      } else {
        this.showText = '高级查询'
      }
    },
    // 重置
    reset () {
      this.loadList = true
      this.forSonTerms = [{
        inOperator: 'and',
        terms: [{
          attr: 'attr',
          attr_label: '',
          relationship: '',
          relationOptions: [{
            value: 'equal',
            label: '等于'
          }, {
            value: 'not_equal',
            label: '不等于'
          }, {
            value: 'contain',
            label: '包含'
          }, {
            value: 'empty',
            label: '为空'
          },
          {
            value: 'not_empty',
            label: '不为空'
          }
          ],
          value: null,
          option: [],
          //              original_id: null,
          //              eventAttributeList: [],
          //              activitiesTwo: [],
          //              templatesTwo: [],
          //              wepageTwo: [],
          eventAttrOptions: [{
            attributeContent: '',
            relationOptions: [],
            sources: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_type: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValueStart: '',
            attributeValueEnd: '',
            attributeValue: ''
          }],
          //              optionOther: null,
          //              qrcodeOptions: null,
          //              templateOption: null,
          //              qrcode: null,
          //              offline_qrcode: null,
          //              template_id: null,
          //              leave_word: null,
          //              public_reply_type_all: {
          //                reply_type: '不限',
          //                reply_content: ''
          //              },
          //              eventLimitTime: false,
          //              eventLimitTimes: false,
          eventLimitAttr: false,
          eventTimeRelation: null,
          //              eventDateStart: '',
          //              eventDateEnd: '',
          happenedTimes: null,
          //              start_time: '',
          //              end_time: '',
          selectedOptions: ['attr', '']
        }]
      }]
      this.page = 1
      this.allTerms.termsGroup = this.forSonTerms
      this.searchTerms = JSON.parse(JSON.stringify(this.allTerms))
      this.searchQuery()
      this.setQuery({})
      this.isHight = false
    },
    // 打开保存筛选弹窗
    saveSearchItem () {
      // 清空校验
      this.saveSearch = true
      this.$nextTick(()=>{
        this.$refs.saveSearchForm.resetFields() //等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.resetFields()，去除验证
      })
    },
    // 确认添加为动态群组
    confirmAddGroup () {
      // 判断是否为空  this.allTerms.termsGroup
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      for (let item of this.allTerms.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          // one.relationOptions = null
          // one.optionOther = null
          // one.qrcodeOptions = null
          // one.templateOption = null
        }
      }
      // 防止重复点击
      this.isDisabledQuery = true
      // 过滤不必要的参数
      // let termData = _g.getCondition(this.allTerms)
      addGroup(this.addGroupForm.name, 1, this.allTerms).then((res) => {
        if (res.data.code === 0) {
          this.isDisabledQuery = false
          this.addGroup = false
          router.push('/home/group-manage')
          _g.toastMsg('success', '添加群组成功')
        } else {
          this.isDisabledQuery = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取子组件的查询条件
    getAllTerms (value) {
      this.isSearch = false
      console.log(value, '接受的参数----')
      this.allTerms = value
    },
    // 确认保存筛选条件
    confirmSaveSearch () {
      for (let item of this.allTerms.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          // one.relationOptions = null
          // one.optionOther = null
          // one.qrcodeOptions = null
          // one.templateOption = null
        }
      }

      // 过滤不必要的参数
      // let termData = _g.getCondition(this.allTerms)
      if (this.saveSearchForm.name === '') {
        _g.toastMsg('error', '筛选条件名字不能为空')
        return
      }
      this.isDisabledSearch = true
      let modelId = this.$route.params.id
      addAudSearchCondition(this.saveSearchForm.name, modelId, 0, JSON.stringify(this.allTerms)).then((res) => {
        if (res.data.code == 200) {
          _g.toastMsg('success', '添加成功')
          this.saveSearch = false
          this.getQueryconditionAction(modelId)
          this.isDisabledSearch = false
          this.saveSearchForm.name = ''
        } else {
          _g.toastMsg('error', res.data.error)
          this.isDisabledSearch = false
          this.saveSearchForm.name = ''
        }
      })
    },
    // 保存为动态群组
    addQuery () {
      this.addGroup = true
    },
    // 点击开始查询
    startSearchQuery () {
      this.isShowSearchRes = false
      this.searchType = 1
      // 判断是否为空
      if(this.isSearch) {
        this.allTerms.termsGroup = this.searchTerms.termsGroup
      }
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      this.is_searched = true
      this.searchTerms = JSON.parse(JSON.stringify(this.allTerms))
      this.searchQuery()
    },
    // 开始高级查询
    searchQuery () {
      this.loadList = true
      this.page = 1
      let modelId = this.$route.params.id
      let termsSend = Object.assign({}, JSON.parse(JSON.stringify(this.searchTerms)))
      if (termsSend.termsGroup !== undefined) {
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            // 删除无用属性
            // 判断是否属性attr
            if (one.selectedOptions[0] === 'attr') {
              delete one.eventAttrOptions
              delete one.eventDateEnd
              delete one.eventDateStart
              delete one.eventTimeRelation
            }
            // 判断是否存在关系属性
            if(one.hasOwnProperty('relationOptions')) {
              delete one.relationOptions
            }
            // 判断是否事件event
            if (one.selectedOptions[0] === 'event') {
              if (one.eventLimitTime === true) {
                one.eventDateStart = this.evalTime(one.eventDateStart)
                one.eventDateEnd = this.evalTime(one.eventDateEnd)
              }
              one.secAttr = one.selectedOptions[2]
              for (let o of one.eventAttrOptions) {
                delete o.sources
                delete o.relationOptions
                delete o.eventAttrValueOptions
              }
              delete one.startValue
              delete one.endValue
              // delete one.relationship 限制次数的必传字段，作用是标识 到底是大于 小于还是区间等等
            } else {
              one.secAttr = one.selectedOptions[1].split('@')[0]
            }
            // 判断是否群组group/标签aud_portary
            if (one.selectedOptions[0] === 'group' || one.selectedOptions[0] === 'aud_portary') {
              delete one.eventAttrOptions
              delete one.eventDateEnd
              delete one.eventDateStart
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            delete one.eventLimitAttr
            delete one.eventLimitTime
            delete one.eventLimitTimes
            delete one.original_id
            delete one.option
            delete one.relationOptions
            delete one.eventAttributeList
            delete one.end_time
            delete one.start_time
            delete one.attr_label
            delete one.eventTimeRelation
            delete one.selectedOptions
          }
        }
      }
      // 都箭头函数了，咱也不知道还用that干啥
      let that = this
      // 过滤不必要的参数
      let newRowList = []
      this.rowList.map(function(item,index){
        if(item.isChecked === 1) {
          newRowList.push(item)
        }
      })
      this.loadList = true
      getAudiencesList(this.page, this.limit, termsSend, modelId, newRowList, null).then((res) => {
        if (res.data.code == 200) {
          that.isHight = true
          for (let one of res.data.result.header) {
            if (one.type === 'number' || one.type === 'datePicker' || one.type === 'dateTimePicker') {
              one.isSort = 'custom'
            }
          }
          for (let child of res.data.result.list) {
            if (child.sys_create_time === '1970-01-01 08:00:00') {
              child.sys_create_time = ''
            }
            if (child.birthday === '1900-01-01') {
              child.birthday = ''
            }
          }
          that.headerList = res.data.result.header
          that.tableData = res.data.result.list
          that.totalCount = res.data.result.total
          this.loadList = true
        } else {
          this.loadList = false
          this.handleInitList()
        }

        // this.loadList = false
        that.openLoading()
      })
      // 保存筛选条件到本地
      this.setQuery(this.allTerms)
    },
    handleInitList () {
      // this.loadList = false
      this.isHight = false
      this.headerList = []
      this.tableData = []
      this.totalCount = 0
    },
    // 解析时间
    evalTime (time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let mon = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return year + '-' + mon + '-' + day + ' ' + h + ':' + m + ':' + s
    },
    // 收起筛选和展开筛选
    closeAndOpen () {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange (page) {
      if (page > 1000) {
        _g.toastMsg('error', '在线查看只允许查看1000页以内内容，查看更多请导出。')
        return
      }
      this.page = page
      this.load()
    },
    // 加载属性取前六个的列表（常用）
    loadSix (modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      this.rowList = []
      this.headerList = []
      getAudListShowSix(modelId).then((audListShowSixRes) => {
        if (audListShowSixRes.data.code == 200) {
          getCusAttrList(modelId).then((res) => {
            if (res.data.code == 200) {
              let data = res.data.result
              let normal = []
              let notNormal = []
              for (let attr of data) {
                if (attr.isNormal === 0) {
                  notNormal.push(attr)
                } else {
                  normal.push(attr)
                }
              }
              // 总的设置列属性
              this.rowData = []
              let arr = JSON.parse(audListShowSixRes.data.result.fields)
              for (let a of arr) {
                for (let item of normal) {
                  if (item.identity === a.identity) {
                    a.name = item.name
                  }
                }
              }
              // 处理设置列选中
              this.checkedRowData = []
              // 处理发给后台的表头
              this.rowData = arr
              let checkedAttr = []
              for (let item of this.rowData) {
                checkedAttr.push(item.identity)
              }
              this.checkedAttr = checkedAttr
              for (let one of arr) {
                if (one.isChecked === 1) {
                  this.rowList.push(one)
                  this.checkedRowData.push(one.identity)
                }
              }
              // console.log(this.checkedRowData, '选中的值')
              this.checkAllAttr = this.checkedRowData.length === this.checkedAttr.length
              this.isIndeterminate = this.checkedRowData.length > 0 && this.checkedRowData.length < this.checkedAttr.length
              this.load(modelId)
            }
          })
        }
      })
    },
    // 加载列表
    load (modelId) {
      let that = this
      this.loadList = true

      let termsSend = Object.assign({}, JSON.parse(JSON.stringify(this.searchTerms)))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          if(one.hasOwnProperty('relationOptions')) {
            delete one.relationOptions
          }
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          // one.relationOptions = null
          one.startValue = one.startValue + ''
          one.endValue = one.endValue + ''
        }
      }
      if (!modelId) {
        modelId = this.$route.params.id
      }
      let newRowList = []
      this.rowList.map(function(item,index){
        if(item.isChecked === 1) {
          newRowList.push(item)
        }
      })
      getAudiencesList(this.page, this.limit, termsSend, modelId, newRowList, null).then((res) => {
        if (res.data.code == 200) {
          for (let one of res.data.result.header) {
            if (one.type === 'number' || one.type === 'datePicker' || one.type === 'dateTimePicker') {
              one.isSort = 'custom'
            }
          }
          for (let child of res.data.result.list) {
            if (child.sys_create_time === '1970-01-01 08:00:00') {
              child.sys_create_time = ''
            }
            if (child.birthday === '1900-01-01') {
              child.birthday = ''
            }
          }
          this.headerList = res.data.result.header
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
          setTimeout(function(){
            that.loadList = false
          },100)
        } else {
          that.loadList = false
          this.handleInitList()
        }

        // this.openLoading()
      })
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loadList = false
      }, 100)
    },
    // 删除
    deleteItem (item) {
      let modelId = this.$route.params.id
      this.$confirm('确认删除该受众?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAudience(modelId, item.id).then((res) => {
          if (res.data.code == 200) {
            _g.toastMsg('success', res.data.message)
            for (let i in this.tableData) {
              if (this.tableData[i].id === item.id) {
                this.tableData.splice(i, 1)
              }
            }
            setTimeout(res => {
              this.load(modelId)
            }, 1000)

          }
        })
      })
    },
    // 弹窗确定
    confirmAdd () {
      // let reg = new RegExp('^\\s*\\w+(?:\\.{0,1}[\\w-]+)*@[a-zA-Z0-9]+(?:[-.][a-zA-Z0-9]+)*\\.[a-zA-Z]+\\s*$')
      // if (!reg.test(this.addForm.email)) {
      //  _g.toastMsg('error', '请输入正确邮箱')
      //  return
      // }
      for (let item of this.attributeList) {
        if (this.customer[item.identity] === '' || this.customer[item.identity].length === 0) {
          _g.toastMsg('error', '请输入' + item.name)
          return
        }
      }
      //  修改地址参数
      let aud = JSON.parse(JSON.stringify(this.customer))
      for (let item of this.attributeList) {
        for (let key in aud) {
          if (item.type === 'addressPicker') {
            if (item.identity === key) {
              let codes = aud[key]
              if (codes.length === 1) {
                aud[key] = {
                  code: codes,
                  text: [CodeToText[codes[0]]]
                }
              }
              if (codes.length === 2) {
                aud[key] = {
                  code: codes,
                  text: [CodeToText[codes[0]], CodeToText[codes[1]]]
                }
              }
              if (codes.length === 3) {
                aud[key] = {
                  code: codes,
                  text: [CodeToText[codes[0]], CodeToText[codes[1]], CodeToText[codes[2]]]
                }
              }
            }
          }
          if (item.type === 'model') {
            if (item.identity === key) {
              let arr = aud[key]
              aud[key] = {
                'modelId': JSON.parse(item.options)[0].modelId,
                'relationAttrId': JSON.parse(item.options)[1].attrId,
                'relationDataList': arr
              }
            }
          }
          if (item.type === 'number') {
            if (item.identity === key) {
              aud[key] = parseInt(aud[key])
            }
          }
        }
      }
      // 添加弹窗
      this.isDisabled = true
      let id = this.$route.params.id
      addAudiences(id, aud).then((res) => {
        if (res.data.code == 200) {
          this.adddialog = false
          this.isDisabled = false
          setTimeout(() => {
            this.load()
          }, 2000)
          _g.toastMsg('success', '添加成功')
          this.$refs.customer.resetFields()
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取属性给新建（常用且必填）
    getCustomerAttributeList (id) {
      if (!id) {
        id = this.$route.params.id
      }
      this.attributeList = []
      this.addForm = {}
      getCusAddAttrList(id).then((res) => {
        if (res.data.code == 200) {
          for (let one of res.data.result) {
            if (one.type === 'multipleSelect' || one.type === 'model') {
              this.$set(this.customer, one.identity, [])
            }
            if (one.options !== '' && one.type !== 'model') {
              // 解析json 捕获异常
              try {
                one.option = JSON.parse(one.options)
              } catch (error) {
                console.log(error)
              }
            }
            if (one.type === 'model' && one.options) {
              let modelId = JSON.parse(one.options)[0].modelId
              let identity = JSON.parse(one.options)[2].identity
              getMyAboutModelList(modelId, identity, '').then((res) => {
                if (res.data.code == 200) {
                  one.option = res.data.result.list
                }
              })
            }
          }
          this.attributeList = res.data.result
        }
      })
    },
    // 打开添加弹窗
    openDialog () {
      this.adddialog = true
      this.addForm.name = ''
      this.addForm.phone = ''
      this.addForm.email = ''
    },
    // 关闭弹窗
    cancelAdd () {
      this.adddialog = false
    }
  },
  // 修改列表页的meta值，false时再次进入页面会重新请求数据。
  //  beforeRouteLeave(to, from, next) {
  //    from.meta.keepAlive = false
  //    to.meta.keepAlive = false
  //    next()
  //  },
  mounted () {
    this.getButtonsList()
  },
  created () {
    this.loadList = true
    this.tableData = [{}]
    let query = JSON.parse(sessionStorage.getItem('audQuery'))
    if (!query){
      // xx
    }
    console.log('初始加载---')
    this.getCustomerAttributes()
    // this.searchQuery()
  },
  watch:{
    // $route(to,from){
    //
    // },
    // 监听路由变化判断是否显示列表上的提示文字
    $route: {
      handler (val) {
        console.log('变化加载---')
        this.tableData = []
        // this.loadSix()
        this.getCustomerAttributes()
        this.paramsId = this.$route.params.id
        if (this.searchOptions.length ===0) {
          this.getQueryconditionAction(this.$route.params.id)
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log('beforeRouteEnter')
      // 判断是不是safari浏览器
      let userAgent = window.navigator.userAgent // 取得浏览器的userAgent字符串
      if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
        vm.isSafari = true
      } else {
        vm.isSafari = false
      }
      vm.searchValue = ''
      vm.loadSource()
      vm.loadStage(to.params.id)
      vm.getQueryconditionAction(to.params.id)
      vm.getAudiencesName(to.params.id, to)
      vm.getCustomerAttributeList(to.params.id)
      vm.customer = {}
      vm.allTerms = {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                attr_label: '',
                relationship: '',
                relationOptions: [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not_empty',
                    label: '不为空'
                  }
                ],
                value: null,
                option: [],
                startValue: '',
                endValue: '',
                // original_id: null,
                // eventAttributeList: [],
                // activitiesTwo: [],
                // templatesTwo: [],
                // wepageTwo: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                // optionOther: null,
                // qrcodeOptions: null,
                // templateOption: null,
                // qrcode: null,
                // offline_qrcode: null,
                // template_id: null,
                // leave_word: null,
                // public_reply_type_all: {
                //  reply_type: '不限',
                //  reply_content: ''
                // },
                // eventLimitTime: false,
                // eventLimitTimes: false,
                // eventDateStart: '',
                // eventDateEnd: '',
                happenedTimes: '',
                eventLimitAttr: false,
                eventTimeRelation: null,
                // start_time: '',
                // end_time: '',
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
      }
      let modelId = vm.$route.params.id
      vm.searchTerms = JSON.parse(JSON.stringify(vm.allTerms))
      vm.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '',
              relationship: '',
              relationOptions: [
                {
                  value: 'equal',
                  label: '等于'
                }, {
                  value: 'not_equal',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not_empty',
                  label: '不为空'
                }
              ],
              value: null,
              option: [],
              startValue: '',
              endValue: '',
              //                original_id: null,
              //                eventAttributeList: [],
              //                activitiesTwo: [],
              //                templatesTwo: [],
              //                wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              //                optionOther: null,
              //                qrcodeOptions: null,
              //                templateOption: null,
              //                qrcode: null,
              //                offline_qrcode: null,
              //                template_id: null,
              //                leave_word: null,
              //                public_reply_type_all: {
              //                  reply_type: '不限',
              //                  reply_content: ''
              //                },
              //                eventLimitTime: false,
              //                eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              //                eventDateStart: '',
              //                eventDateEnd: '',
              happenedTimes: '',
              //                start_time: '',
              //                end_time: '',
              selectedOptions: ['attr', '']
            }
          ]
        }
      ]
      // 通过 `vm` 访问组件实例
      let query = JSON.parse(sessionStorage.getItem('audQuery'))
      let audQueryModelId = JSON.parse(sessionStorage.getItem('audQueryModelId'))
      if (query) {
        if (audQueryModelId == to.params.id) {
          for (let one of query.termsGroup) {
            for (let item of one.terms) {
              // 回显属性
              if (item.selectedOptions[0] === 'attr') {
                // 回显客户等级与来源
                if (item.selectedOptions[1].split('@')[0] === 'source_id') {
                  getSourceData().then((res) => {
                    item.option = res.data.data.list
                  })
                }
                if (item.selectedOptions[1].split('@')[0] === 'stage_id') {
                  getCusStageList(audQueryModelId).then((res) => {
                    item.option = res.data.result
                    item.option.unshift({
                      name: '未知等级',
                      id: 0
                    })
                  })
                }
                /* -------------自定义属性的相对关系------------ */
                // 文本
                if (item.selectedOptions[1].split('@')[1] === 'input') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                // 单个选择列表
                if (item.selectedOptions[1].split('@')[1] === 'select') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                // 时间
                if (item.selectedOptions[1].split('@')[1] === 'datePicker' || item.selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'lt',
                      label: '早于'
                    }, {
                      value: 'gt',
                      label: '晚于'
                    }, {
                      value: 'gtele',
                      label: '区间'
                    }, {
                      value: 'empty',
                      label: '为空'
                    }, {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                // 地址
                if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                // 多个选择列表
                if (item.selectedOptions[1].split('@')[1] === 'multipleSelect') {
                  item.relationOptions = [
                    {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                // 数值
                if (item.selectedOptions[1].split('@')[1] === 'number') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'gt',
                      label: '大于'
                    }, {
                      value: 'lt',
                      label: '小于'
                    }, {
                      value: 'gtele',
                      label: '区间'
                    }
                  ]
                }
                // 关联模型
                if (item.selectedOptions[1].split('@')[1] === 'model') {
                  item.relationOptions = [
                    {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
              }
              if (item.selectedOptions[0] === 'aud_portary') {
                /* -------------自定义属性的相对关系------------ */
                // 文本
                if (item.selectedOptions[1].split('@')[0] === 'tag') {
                  item.relationOptions = [
                    {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
              }
              // 回显群组
              if (item.selectedOptions[0] === 'group') {
                getAudGroupList(modelId, 1, 1000000000, '', '').then((res) => {
                  // 获取群组分组
                  getAudGroupGroupList(modelId, '').then((respo) => {
                    if (respo.data.code == 200) {
                      // 设置分组
                      respo.data.result.unshift({
                        id: 0,
                        name: '全部'
                      })
                      for (let item of respo.data.result) {
                        item.children = []
                        item.label = item.name
                        item.value = item.id
                      }
                      // 普通分组群组
                      for (let one of res.data.result.list) {
                        for (let item of respo.data.result) {
                          if (one.groupId == item.id) {
                            item.children.push({
                              label: one.name,
                              value: one.id
                            })
                          }
                        }
                      }
                      // 全部分组群组
                      respo.data.result[0].children = []
                      for (let one of res.data.result.list) {
                        respo.data.result[0].children.push({
                          label: one.name,
                          value: one.id,
                        })
                      }
                      item.option = respo.data.result
                    }
                  })
                })
              }
              // 回显事件
              if (item.selectedOptions[0] === 'event') {
                // 回显微信公众号
                if (item.selectedOptions[1] === 'wechat') {
                  getWechatPublicListForNode(1, '').then((res) => {
                    res.data.data.list.unshift({
                      label: '不限',
                      nick_name: '不限',
                      id: '',
                      value: ''
                    })
                    for (let ite of res.data.data.list) {
                      ite.label = ite.nick_name
                      ite.value = ite.id
                      // 扫描线下活动二维码
                      if (item.selectedOptions[2].split('@')[0] === 'scan_offline_qrcode') {
                        if (item.value === ite.id) {
                          item.optionOther = ite.offline
                        }
                      }
                      // 扫描公众号二维码
                      if (item.selectedOptions[2].split('@')[0] === 'scan_qrcode') {
                        if (item.value === ite.id) {
                          item.qrcodeOptions = ite.qrcode
                        }
                        getQrCodeList().then((res) => {
                        })
                      }
                      // 发送模板消息
                      if (item.selectedOptions[2].split('@')[0] === 'send_tpl_message') {
                        if (item.value === ite.id) {
                          item.templateOption = ite.template
                        }
                      }
                    }
                    item.option = res.data.data.list
                  })
                }
                // 回显微页面
                if (item.selectedOptions[1] === 'wepage') {
                  WePagesList(1, { publish_status: '' }).then((res) => {
                    for (let ite of res.data.data.list) {
                      ite.label = ite.admin_title
                      ite.value = ite.id
                    }
                    item.option = res.data.data.list
                  })
                }
                // 回显短信
                if (item.selectedOptions[1] === 'sms') {
                  getMessageListForNode(1, '').then((res) => {
                    for (let ite of res.data.data.list) {
                      ite.label = ite.sms_name
                      ite.value = ite.id
                    }
                    item.option = res.data.data.list
                  })
                }
                // 回显互动活动（大转盘）
                if (item.selectedOptions[1] === 'interactive_activities') {
                  getBigWheelList().then((res) => {
                    for (let ite of res.data.data.list) {
                      ite.label = ite.name
                      ite.value = ite.id
                    }
                    item.option = res.data.data.list
                  })
                }
              }
              // 回显关注公众号
              if (item.selectedOptions[0] === 'follow_public') {
                // 回显微信公众号
                getWechatPublicListForNode(1, '').then((res) => {
                  for (let ite of res.data.data.list) {
                    ite.label = ite.nick_name
                    ite.value = ite.original_id
                  }
                  item.option = res.data.data.list
                })
              }
              // 回显客户身份
              if (item.selectedOptions[0] === 'customer_identity') {
                item.relationOptions = [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ]
              }
              // 回显微页面
              if (item.selectedOptions[1] === 'wepage') {
                WePagesList(1, { publish_status: '' }).then((res) => {
                  for (let ite of res.data.data.list) {
                    ite.label = ite.admin_title
                    ite.value = ite.id
                  }
                  item.option = res.data.data.list
                })
              }
              // 回显短信
              if (item.selectedOptions[1] === 'sms') {
                getMessageListForNode(1, '').then((res) => {
                  for (let ite of res.data.data.list) {
                    ite.label = ite.sms_name
                    ite.value = ite.id
                  }
                  item.option = res.data.data.list
                })
              }
              // 回显互动活动（大转盘）
              if (item.selectedOptions[1] === 'interactive_activities') {
                getBigWheelList().then((res) => {
                  for (let ite of res.data.data.list) {
                    ite.label = ite.name
                    ite.value = ite.id
                  }
                  item.option = res.data.data.list
                })
              }
              // 客户关键指标
              if (item.selectedOptions[0] === 'customer_kpi') {
                item.relationOptions = [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'gt',
                    label: '大于'
                  },
                  {
                    value: 'lt',
                    label: '小于'
                  },
                  {
                    value: 'gtele',
                    label: '区间'
                  }
                ]
              }
            }
          }
          vm.allTerms = query
          vm.searchTerms = query
          vm.hide = true
          vm.forSonTerms = vm.allTerms.termsGroup
          vm.allRelationshipSearch = vm.allTerms.allRelationship
          sessionStorage.removeItem('audQuery')
        }
        sessionStorage.removeItem('audQuery')
        vm.searchType = 1
      } else {
        vm.allTerms = {
          allRelationship: 'and',
          termsGroup: [
            {
              inOperator: 'and',
              terms: [
                {
                  attr: 'attr',
                  attr_label: '',
                  relationship: '',
                  modelItemId: '',
                  relationOptions: [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ],
                  value: null,
                  option: [],
                  startValue: '',
                  endValue: '',
                  // original_id: null,
                  // eventAttributeList: [],
                  // activitiesTwo: [],
                  // templatesTwo: [],
                  // wepageTwo: [],
                  eventAttrOptions: [
                    {
                      attributeContent: '',
                      relationOptions: [],
                      sources: [],
                      eventAttrValueOptions: [],
                      attributeRelation: '',
                      attr_type: '',
                      attrValTimeStart: '',
                      attrValTimeEnd: '',
                      attributeValueStart: '',
                      attributeValueEnd: '',
                      attributeValue: ''
                    }
                  ],
                  // optionOther: null,
                  // qrcodeOptions: null,
                  // templateOption: null,
                  // qrcode: null,
                  // offline_qrcode: null,
                  // template_id: null,
                  // leave_word: null,
                  // public_reply_type_all: {
                  //  reply_type: '不限',
                  //  reply_content: ''
                  // },
                  // eventLimitTime: false,
                  // eventLimitTimes: false,
                  eventLimitAttr: false,
                  eventTimeRelation: null,
                  // eventDateStart: '',
                  // eventDateEnd: '',
                  happenedTimes: null,
                  // start_time: '',
                  // end_time: '',
                  selectedOptions: ['attr', '']
                }
              ]
            }
          ]
        }
        vm.forSonTerms = [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                attr_label: '',
                relationship: '',
                modelItemId: '',
                relationOptions: [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not_empty',
                    label: '不为空'
                  }
                ],
                value: null,
                option: [],
                startValue: '',
                endValue: '',
                //                original_id: null,
                //                eventAttributeList: [],
                //                activitiesTwo: [],
                //                templatesTwo: [],
                //                wepageTwo: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                //                optionOther: null,
                //                qrcodeOptions: null,
                //                templateOption: null,
                //                qrcode: null,
                //                offline_qrcode: null,
                //                template_id: null,
                //                leave_word: null,
                //                public_reply_type_all: {
                //                  reply_type: '不限',
                //                  reply_content: ''
                //                },
                //                eventLimitTime: false,
                //                eventLimitTimes: false,
                eventLimitAttr: false,
                eventTimeRelation: null,
                //                eventDateStart: '',
                //                eventDateEnd: '',
                happenedTimes: null,
                //                start_time: '',
                //                end_time: '',
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
        vm.hide = true
      }
      vm.handleInitList()
      // vm.searchQuery()
      vm.loadSix(to.params.id)
    })
  },
  beforeRouteLeave (to, from, next) {
    console.log('beforeRouteLeave')
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (to.path.indexOf('/home/model-business') != -1 || to.path.indexOf('/home/model-consumer') != -1) {
      let termsSend = JSON.parse(JSON.stringify(this.searchTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.startValue = one.startValue + ''
          one.endValue = one.endValue + ''
          // one.relationOptions = null
          // one.optionOther = null
          // one.qrcodeOptions = null
          // one.templateOption = null
          // one.eventAttributeList = null

          // for (let yi of one.eventAttrOptions) {
          // yi.eventAttrValueOptions = null
          // yi.relationOptions = null
          // }
        }
      }
      sessionStorage.setItem('audQuery', JSON.stringify(termsSend))
      let modelId = from.params.id
      sessionStorage.setItem('audQueryModelId', modelId)
    } else {
      sessionStorage.setItem('audQueryModelId', '0')
    }
    this.loadList = true
    next()
  },
  beforeRouteUpdate (to, from, next) {
    // 判断是不是safari浏览器
    console.log('beforeRouteUpdate')
    let userAgent = window.navigator.userAgent // 取得浏览器的userAgent字符串
    if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
      this.isSafari = true
    } else {
      this.isSafari = false
    }
    this.handleInitList()
    this.searchValue = ''
    this.page = 1
    this.loadSource()
    this.loadSix(to.params.id)
    this.loadStage(to.params.id)
    this.getQueryconditionAction(to.params.id)
    this.getAudiencesName(to.params.id, to)
    this.getCustomerAttributeList(to.params.id)
    this.customer = {}
    this.allTerms = {
      allRelationship: 'and',
      termsGroup: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '',
              relationship: '',
              modelItemId: '',
              relationOptions: [
                {
                  value: 'equal',
                  label: '等于'
                }, {
                  value: 'not_equal',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not_empty',
                  label: '不为空'
                }
              ],
              value: null,
              option: [],
              startValue: '',
              endValue: '',
              // original_id: null,
              // eventAttributeList: [],
              // activitiesTwo: [],
              // templatesTwo: [],
              // wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              // optionOther: null,
              // qrcodeOptions: null,
              // templateOption: null,
              // qrcode: null,
              // offline_qrcode: null,
              // template_id: null,
              // leave_word: null,
              // public_reply_type_all: {
              //  reply_type: '不限',
              //  reply_content: ''
              // },
              // eventLimitTime: false,
              // eventLimitTimes: false,
              // eventLimitAttr: false,
              // eventTimeRelation: '',
              // eventDateStart: '',
              // eventDateEnd: '',
              // happenedTimes: '',
              // start_time: '',
              // end_time: '',
              selectedOptions: ['attr', '']
            }
          ]
        }
      ]
    }
    this.searchTerms = {
      allRelationship: 'and',
      termsGroup: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '',
              relationship: '',
              modelItemId: '',
              relationOptions: [
                {
                  value: 'equal',
                  label: '等于'
                }, {
                  value: 'not_equal',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not_empty',
                  label: '不为空'
                }
              ],
              value: null,
              option: [],
              startValue: '',
              endValue: '',
              // original_id: null,
              // eventAttributeList: [],
              // activitiesTwo: [],
              // templatesTwo: [],
              // wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              // optionOther: null,
              // qrcodeOptions: null,
              // templateOption: null,
              // qrcode: null,
              // offline_qrcode: null,
              // template_id: null,
              // leave_word: null,
              // public_reply_type_all: {
              //  reply_type: '不限',
              //  reply_content: ''
              // },
              // eventLimitTime: false,
              // eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              // eventDateStart: '',
              // eventDateEnd: '',
              happenedTimes: null,
              // start_time: '',
              // end_time: '',
              selectedOptions: ['attr', '']
            }
          ]
        }
      ]
    }
    this.forSonTerms = [
      {
        inOperator: 'and',
        terms: [
          {
            attr: 'attr',
            attr_label: '',
            relationship: '',
            modelItemId: '',
            relationOptions: [
              {
                value: 'equal',
                label: '等于'
              }, {
                value: 'not_equal',
                label: '不等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ],
            value: null,
            option: [],
            startValue: '',
            endValue: '',
            //                original_id: null,
            //                eventAttributeList: [],
            //                activitiesTwo: [],
            //                templatesTwo: [],
            //                wepageTwo: [],
            eventAttrOptions: [
              {
                attributeContent: '',
                relationOptions: [],
                sources: [],
                eventAttrValueOptions: [],
                attributeRelation: '',
                attr_type: '',
                attrValTimeStart: '',
                attrValTimeEnd: '',
                attributeValueStart: '',
                attributeValueEnd: '',
                attributeValue: ''
              }
            ],
            //                optionOther: null,
            //                qrcodeOptions: null,
            //                templateOption: null,
            //                qrcode: null,
            //                offline_qrcode: null,
            //                template_id: null,
            //                leave_word: null,
            //                public_reply_type_all: {
            //                  reply_type: '不限',
            //                  reply_content: ''
            //                },
            //                eventLimitTime: false,
            //                eventLimitTimes: false,
            eventLimitAttr: false,
            eventTimeRelation: null,
            //                eventDateStart: '',
            //                eventDateEnd: '',
            happenedTimes: null,
            //                start_time: '',
            //                end_time: '',
            selectedOptions: ['attr', '']
          }
        ]
      }
    ]
    this.loadList = true
    next()
  },
}
</script>

<style scoped>
  .el-table .cell span:empty::before{
    content:'——';
    color:gray;
  }
.name-wrapper {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.export-number {
  text-align: left;
  margin-bottom: 20px;
  padding-left: 7px;
}
.save-btn {
  padding: 0 10px;
  height: 30px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #1890FF;
  cursor: pointer;
  border: none;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}

/*  .search-title{
    background:#ecf6ff;
    border:1px solid #ebebeb;
    height:60px;
    padding:10px;
    line-height: 40px;
  }*/
.title-tips {
  /* display: block; */
  font-size: 25px;
  /* height: 39px; */
  position: absolute;
  top: 12px;
  right: 20px;
}
.title-attribute {
  display: none;
  position: absolute;
  z-index: 10;
  top: 50px;
  right: -2px;
  background: #fff;
  box-shadow: 0 5px 7px 7px rgba(144, 140, 140, 0.5);
  padding: 9px;
  border-radius: 8px;
  width: 400px;
}
.title-attribute p {
  text-align: left;
  padding: 5px 0;
  height: 25px;
  line-height: 23px;
}
.set-columns {
  margin-right: 57px !important;
}
</style>
